import { api } from "./api";

export const logsListApi = (params) => {
    return api.get(`/hub/logs/list`, { params: params });
};

export const logsExportApi = (params) => {
    return api.get(`/hub/logs/export`, { params, responseType: 'blob' });
};

export const logsViewApi = (id) => {
    return api.get(`/hub/logs/view`, { params: { id } });
};

export const getSignedUrlApi = (fileUrl) => {
    return api.post(`/translator/get-url`, { fileUrl });
};
